import { render } from "./WiderrufsbelehrungSection.vue?vue&type=template&id=3dd7014d&scoped=true"
import script from "./WiderrufsbelehrungSection.vue?vue&type=script&lang=js"
export * from "./WiderrufsbelehrungSection.vue?vue&type=script&lang=js"

import "./WiderrufsbelehrungSection.vue?vue&type=style&index=0&id=3dd7014d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd7014d"]])

export default __exports__